// extracted by mini-css-extract-plugin
export default {"table_grid_columns_header":"ui_table_grid_columns_header__MbDhs","table_grid_columns_row":"ui_table_grid_columns_row__WxSZJ","hidden_500":"ui_hidden_500__h6LHT"};